import { render } from "./CreateUserAddressModal.vue?vue&type=template&id=75105422"
import script from "./CreateUserAddressModal.vue?vue&type=script&lang=js"
export * from "./CreateUserAddressModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__